import FeeDescriptionModalController from '../common/modal_controller'

// 実装は common/modal_controller.js にあり、ここでは識別子の登録のためだけに継承する。
// このモーダルにDesktop版は無い（PCはホバー表示。common/component.rb のコメント参照）。
export default class extends FeeDescriptionModalController {}
